import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { TrackingLocation } from '@tracking';

import OrgChartsGridView from '../GridView';
import { MoreOrgChartsProps } from './interfaces';

const MoreOrgCharts = (props: MoreOrgChartsProps) => {
  const { Track } = useEventTracking({
    location: TrackingLocation.OrgChartMoreOrgChartsGrid,
  });
  return (
    <Track>
      <aside className="mt-64 flex flex-col gap-6 sm:mt-[78px]">
        <h3 className="font-suisse-intl-mono">More Org Charts</h3>
        <OrgChartsGridView companies={props.companies} />
      </aside>
    </Track>
  );
};

export default MoreOrgCharts;
